const getters = {
  roles: state => state.permission.roles,
  permission_routes: state => state.permission.routes,
}
export default getters
